export default __webpack_public_path__ + "static/media/NuleepBlack.462101a1.svg";